import React from 'react'
import { Box, Stack, Text } from '@chakra-ui/react'
import { TransferDetailsFields, TransferForm } from '@Types'
import { isEmpty } from 'lodash'

export interface wireDetailsProps {
  fields: TransferForm
}

const CancelTransferModalWireDetails = ({ fields }: wireDetailsProps) => {
  const { transferDate } = fields
  const { transferType, transferAmount, accounts, wireDetails } = fields.transferDetails as TransferDetailsFields
  return (
    <Stack spacing='8'>
      <Stack direction='row' spacing='5'>
        <Box width={7.5 / 16}>
          <Text>Transfer Type</Text>
          <Text>{transferType.display}</Text>
        </Box>
        <Box width={7.5 / 16}>
          <Text>Transfer Amount</Text>
          <Text>{transferAmount.display}</Text>
        </Box>
      </Stack>

      <Box>
        <Text>From Account</Text>
        <Text>{accounts.from.display}</Text>
      </Box>
      <Stack direction='row' spacing='5'>
        <Box width={7.5 / 16}>
          <Text>Beneficiary Name</Text>
          <Text>{wireDetails?.beneficiaryDetails?.name}</Text>
        </Box>
        <Box width={7.5 / 16}>
          <Text>Account # or IBAN</Text>
          <Text>{wireDetails?.beneficiaryDetails?.account}</Text>
        </Box>
      </Stack>
      <Stack direction='row' spacing='5'>
        {wireDetails?.recipientBankDetails?.name && (
          <Box width={7.5 / 16}>
            <Text>Bank Name</Text>
            <Text>{wireDetails?.recipientBankDetails?.name}</Text>
          </Box>
        )}
        <Box width={7.5 / 16}>
          <Text>
            {isEmpty(wireDetails?.recipientBankDetails?.country)
              ? 'Bank ABA Routing / SWIFT / BIC'
              : 'Bank SWIFT / BIC'}
          </Text>
          <Text>{wireDetails?.recipientBankDetails?.identifierDetails?.id}</Text>
        </Box>
      </Stack>
      <Box>
        <Text>Transfer Date</Text>
        <Text>{transferDate}</Text>
      </Box>
    </Stack>
  )
}

export default CancelTransferModalWireDetails
